import { initBotId } from 'botid/client/core'

// Define the paths that need bot protection. Each endpoint that runs checkBotId()
// on the server must be listed here so the client attaches the BotID token to requests.
// See: https://vercel.com/docs/botid/get-started#add-client-side-protection
// Server actions POST to the current page URL, so every page that can invoke a
// protected action must be covered. getUser() runs from the shared header and
// footer, including on CMS [slug] pages, so POST uses a catch-all below.
// BotID 1.5.11 skips cross-origin XHR. Do not downgrade below that: 1.5.10
// attaches x-is-human to every POST whose path matches /*, including Google
// Maps and Places calls, which the browser then rejects as a 403/CORS error.
initBotId({
  protect: [
    // Header and footer call getUser() on every frontend page, including CMS [slug] routes.
    { path: '/*', method: 'POST' },
    { path: '/about', method: 'POST' },
    { path: '/dashboard', method: 'POST' },
    { path: '/legislative-tracker', method: 'POST' },
    { path: '/legislative-tracker/bills/*', method: 'POST' },
    { path: '/learn', method: 'POST' },
    { path: '/learn/articles/*', method: 'POST' },
    { path: '/', method: 'POST' },
    { path: '/endorsements', method: 'POST' },
    { path: '/sign-in', method: 'POST' },
    { path: '/sign-up', method: 'POST' },
    { path: '/join', method: 'POST' },
    { path: '/auth', method: 'POST' },
    { path: '/auth/*', method: 'POST' },
    { path: '/internships', method: 'POST' },
    { path: '/contact', method: 'POST' },
    { path: '/volunteer', method: 'POST' },
    { path: '/speaker-submission', method: 'POST' },
    { path: '/other-great-organizations', method: 'POST' },
    { path: '/maha-wins', method: 'POST' },
    { path: '/candidate-pledge', method: 'POST' },
    { path: '/api/frontend/organizations/submit', method: 'POST' },
    { path: '/api/frontend/wins/submit', method: 'POST' },
    { path: '/api/stripe/handle-donation', method: 'POST' },
    { path: '/api/stripe/handle-membership', method: 'POST' },
    { path: '/api/form-submissions', method: 'POST' },
    { path: '/api/x-timeline', method: 'GET' },
    { path: '/next/seed', method: 'POST' },
    { path: '/api/jurisdictions', method: 'POST' },
    { path: '/admin/track-and-search-bills', method: 'POST' },
    { path: '/admin/link-bills', method: 'POST' },
    { path: '/admin/upload-legislator-csv', method: 'POST' },
    { path: '/admin/globals/bill-tracker-settings', method: 'POST' },
    // List views post to the collection path itself. The wildcard does not match that URL.
    { path: '/admin/collections/bills', method: 'POST' },
    { path: '/admin/collections/bills/*', method: 'POST' },
    { path: '/admin/collections/legislators', method: 'POST' },
    { path: '/admin/collections/legislators/*', method: 'POST' },
    { path: '/admin/collections/sessions', method: 'POST' },
    { path: '/api/events/generate-pass', method: 'POST' },
    { path: '/events', method: 'POST' },
    { path: '/events/*', method: 'POST' },
  ],
})
